import api, { ApiResponse } from "../api";
import StatusCheckSubAccount from "./StatusCheckSubAccount";

export interface AccountSearchResult {
  accountId: number;
  accountName: string;
  accountAttentionName: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  phone: string;
}

class AccountService {
  private static instance: AccountService;

  private constructor() {}

  static getInstance(): AccountService {
    if (!AccountService.instance) {
      AccountService.instance = new AccountService();
    }

    return AccountService.instance;
  }

  public getStatusCheckAccounts = async (): Promise<
    ApiResponse<StatusCheckSubAccount>
  > => {
    return await api.get("/accounts/status");
  };

  public searchAccountsByNameOrNumber = async (
    search: string
  ): Promise<ApiResponse<AccountSearchResult[]>> => {
    return await api.get("/accounts/search-by-name-or-number", {
      params: { search }
    });
  };
}

export default AccountService;
